export default __webpack_public_path__ + "static/media/main_section11.270d8503.jpg";